var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "login",
      },
      [
        _c("h1", [_vm._v("Ring Neighbor Dashboard")]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "el-button el-button--danger",
            attrs: { href: _vm.vars.API_URL + "/v2/auth/sign_in" },
          },
          [_vm._v("\n      Login with Okta\n    ")]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticStyle: { position: "absolute", bottom: "20px", width: "100%" } },
      [
        _c(
          "div",
          { staticStyle: { "font-size": "12px", "text-align": "center" } },
          [
            _vm._v(
              "\n      Backend: " +
                _vm._s(_vm.vars.API_URL) +
                " - ENV: " +
                _vm._s(_vm.vars.NODE_ENV) +
                " -\n      Version: " +
                _vm._s(_vm.vars.VERSION) +
                " (" +
                _vm._s(_vm.vars.COMMIT) +
                ")\n    "
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }